module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#logic",
      toString: function () {
        return this.url;
      }
    }